// User Model
import { Model } from '@vuex-orm/core';

export default class CourseV4 extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'coursesv4';

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            image: this.attr(''),
            description: this.attr(''),
            salespage: this.attr(''),
            slug: this.attr(''),
            color_theme: this.attr(''),
            module_theme: this.attr(''),
            theme: this.attr(''),
            module_count: this.attr(0),
            lesson_count: this.attr(0),
            last_activity: this.attr(''),
            index: this.attr(0),
            overview_visible: this.attr(false),
            visible_when_available: this.attr(false),
            details_visible: this.attr(false),
            release_date: this.attr(null),
            course_fully_loaded: this.attr(false),
            visibility: this.attr(null),
            availability: this.attr(null),
            participant: this.attr({}),
        };
    }

    static mutators () {
        return {
            release_date (value) {
                if (!value) return null;

                return moment(value).format("YYYY-MM-DD HH:mm:ss");
            },
            image (value) {
                if (!value) return '';

                return value.url + '?width=600';
            },
        };
    }

    get is_released() {
        if (this.release_date === null) {
            return false;
        }

        return Date.now() >= new Date(this.release_date);
    }

    get is_draft() {
        return this.release_date === null;
    }

    get is_planned() {
        return !this.is_released && !this.is_draft;
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                // return a promise with the result so we can use the pagination data
                return new Promise((resolve, reject) => {
                    this.get('/api/v4/e-learning/courses', {
                        params,
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },
        },
    };
}

window.CourseV4 = CourseV4;
